import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADD_SUBSCRIPTION_PURCHASE = 'ADD_SUBSCRIPTION_PURCHASE';
export const ADD_SUBSCRIPTION_PURCHASE_SUCCESS =
  'ADD_SUBSCRIPTION_PURCHASE_SUCCESS';
export const ADD_SUBSCRIPTION_PURCHASE_FAILURE =
  'ADD_SUBSCRIPTION_PURCHASE_FAILURE';

// Action Creators
export const addSubscriptionPurchase = () => ({
  type: ADD_SUBSCRIPTION_PURCHASE,
});

export const addSubscriptionPurchaseSuccess = (users) => ({
  type: ADD_SUBSCRIPTION_PURCHASE_SUCCESS,
  payload: users,
});

export const addSubscriptionPurchaseFailure = (error) => ({
  type: ADD_SUBSCRIPTION_PURCHASE_FAILURE,
  payload: error,
});

// Thunk Function
export const addSubscriptionPurchaseCallAPI = (body, external) => {
  return async (dispatch) => {
    dispatch(addSubscriptionPurchase());
    try {
      const response = await postMethodWithToken(
        url.subscriptionPurchase + body?.userId + '/',
        body?.data
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(addSubscriptionPurchaseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(addSubscriptionPurchaseFailure('error?.message'));
      }
    } catch (error) {
      dispatch(addSubscriptionPurchaseFailure(error?.message));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
